import { Entity } from "src/app/shared/models/entity";

export class VitalSign extends Entity {
  Id: number;
  PatientId: number;
  VSDateTime: Date;
  Height: number;
  Weight: number;
  BT: number;
  Head: number;
  Pulse: number;
  SpO2: number;
  SBP: number;
  DBP: number;
  Waist: number;
  BloodSugarAC: number;
  BloodSugarPC: number;
  Cholesterol: number;
  LMPDate: Date;
  DueDate: Date;
  IsPregnant: boolean;

  // extend properties
  isFemale = false;
  birthday = new Date();
  //VitalSignDisplay: string;

  // #region calc --------------------



  // #endregion calc --------------------
}

/** 單一量測欄位最近一次有值的紀錄（對應後端 LastVitalSignItem） */
export class LastVitalSignItem {
  /** VitalSign 的屬性名稱，與 formControlName 相同 */
  Field: string;
  /** 數值欄位的值；IsPregnant 以 1/0 表示 */
  Value: number;
  /** LMPDate、DueDate 的值 */
  DateValue: Date;
  /** 該值所在量測紀錄的時間 */
  VSDateTime: Date;
}
